import { render } from "./ReportBasicInput.vue?vue&type=template&id=498eea10&scoped=true"
import script from "./ReportBasicInput.vue?vue&type=script&lang=js"
export * from "./ReportBasicInput.vue?vue&type=script&lang=js"

import "./ReportBasicInput.vue?vue&type=style&index=0&id=498eea10&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pablo Sastre\\OneDrive\\Escritorio\\BAIPManagerTestv2\\BaipMarket.Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-498eea10"]])

export default __exports__